module.exports = __webpack_public_path__ + "img/halaip.13ea37ab.jpg";